module.exports = __webpack_public_path__ + "img/banker-green_320.210d9f3d.png";